export const truncateMiddle = (str: string, startLength: number = 20, endLength: number = 10): string => {
  if (str.length <= startLength + endLength) {
    return str;
  }

  const start = str.slice(0, startLength);
  const end = str.slice(-endLength);

  return `${start}…${end}`;
};
